"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const lodash_1 = require("lodash");
const formik_1 = require("formik");
const useStyles = styles_1.makeStyles((theme) => ({
    input: {
        display: 'none',
    },
    label: {
        cursor: 'pointer',
    },
}));
const RenderFileField = (props) => {
    const { field: { name }, form: { touched, errors, submitCount, setFieldValue }, label, color, variant, size, accept, multiple, ...otherProps } = props;
    const classes = useStyles();
    const error = formik_1.getIn(errors, name);
    const touch = formik_1.getIn(touched, name);
    const displayErrors = (touch || submitCount > 0) && !!error;
    const fileId = lodash_1.uniqueId('file_');
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(core_1.Box, null,
            react_1.default.createElement("input", { type: "file", id: fileId, name: name, accept: accept, multiple: multiple, className: classes.input, onChange: (event) => setFieldValue(name, event.currentTarget.files[0]) }),
            react_1.default.createElement("label", { htmlFor: fileId, className: classes.label },
                react_1.default.createElement(core_1.Button, Object.assign({ name: name, component: "span", variant: variant, color: color, size: size }, otherProps), label)),
            displayErrors && (react_1.default.createElement(core_1.Typography, Object.assign({ variant: "body2", component: "p", color: "error" }, otherProps), error)))));
};
RenderFileField.defaultProps = {
    color: 'primary',
    variant: 'outlined',
    size: 'large',
    accept: '*/*',
    multiple: false,
};
RenderFileField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    label: prop_types_1.default.string.isRequired,
    color: prop_types_1.default.string,
    variant: prop_types_1.default.string,
    size: prop_types_1.default.string,
    accept: prop_types_1.default.string,
    multiple: prop_types_1.default.bool,
};
exports.default = RenderFileField;
